<template>
  <v-app id="inspire">
    <my-side-bar :drawer="drawer"></my-side-bar>
    <my-header @changeDrawer="updateDrawer" :drawer="drawer" ></my-header>
    
    <v-main>
      <v-container class="" fluid>
        <v-row class="px-3">
          <v-card>
            <v-card-title cols="12" >
              Gestione Preventivo
              <v-spacer></v-spacer>
            </v-card-title>
           <div>
             <div class="text-center" v-if="isLoading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <v-form ref="form">
              <v-container fluid>
                <v-expansion-panels
                  multiple
                  focusable
                  v-model="panel"
                >
                  <v-expansion-panel>
                    <!--<v-expansion-panel-header>Dati Utenza</v-expansion-panel-header>-->
                    <v-expansion-panel-header v-slot="{ open }" class="box_customer">
                      <v-row no-gutters>
                        <v-col cols="4">
                          CLIENTE
                        </v-col>
                        <v-col
                          cols="8"
                          class="text--secondary"
                        >
                          <v-fade-transition leave-absolute>
                            <span v-if="open" class="info-panel">Gestisci i dati del cliente</span>
                            <v-row
                              v-else
                              no-gutters
                              style="width: 100%"
                            >
                              <v-col cols="6">
                                Nome: {{customer.firstname}}
                              </v-col>
                              <v-col cols="6">
                                Cognome: {{customer.lastname}}
                              </v-col>
                            </v-row>
                          </v-fade-transition>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row cols="12">
                        <v-col cols="12" sm="12" md="12" >
                          <v-autocomplete
                            v-model="customer.obj"
                            :items="items"
                            :loading="isLoading"
                            :search-input.sync="search"
                            @change="customerSelected()"
                            hide-no-data
                            hide-selected
                            item-text="Description"
                            item-value="Cliente"
                            label="Cerca Cliente"
                            placeholder="Inizia a scrivere per cercare"
                            prepend-icon="mdi-account-box-outline"
                            return-object
                          ></v-autocomplete>
                          
                        </v-col>
                      </v-row>
                      <v-row cols="12">
                        <v-col cols="12" sm="6" md="3" >
                          <v-text-field label="Nome" v-model="customer.firstname" readonly></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field label="Cognome" v-model="customer.lastname" readonly></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" >
                          <v-text-field label="Ragione Sociale" v-model="customer.company" readonly></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" >
                          <v-text-field label="Altro" readonly></v-text-field>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel v-if="configurators.length > 0">
                    <!-- <v-expansion-panel-header>Dati Contatto</v-expansion-panel-header> -->
                    <v-expansion-panel-header v-slot="{ open }" class="box_type_configurator">
                      <v-row no-gutters>
                        <v-col cols="4">
                          TIPOLOGIA DI PREVENTIVO
                        </v-col>
                        <v-col
                          cols="8"
                          class="text--secondary"
                        >
                          <v-fade-transition leave-absolute>
                            <span v-if="open" class="info-panel"></span>
                            <v-row
                              v-else
                              no-gutters
                              style="width: 100%"
                            >
                              <v-col cols="6">
                                {{quotation.configurator !== null && quotation.configurator.name !== '' ? quotation.configurator.name : ''}} 
                              </v-col>
                              <v-col cols="6">
                                
                              </v-col>
                            </v-row>
                          </v-fade-transition>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row cols="12">
                        <v-col cols="12" sm="6" md="3">
                          <v-combobox
                            v-model="quotation.configurator"
                            :items="configurators"
                            label="Tipologia di preventivo"
                            @change="changeConfigurator()"
                            item-text="name"
                            item-value="id"
                          ></v-combobox>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel v-if="quotation.configurator">
                    <v-expansion-panel-header class="box_measure">{{quotation.areas.measure.name}}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row no-gutters class="mt-5">
                        <v-col cols="4" md="4" class="pr-2">
                          <v-card class="pa-2">

                            <v-list>
                              <v-list-item v-for="b in quotation.areas.measure.sections_doc[0].blocks" :key="b.id">
                                <v-list-item-content>
                                  <v-row no-gutters>
                                    <v-col cols="12" sm="12" md="12" class="pl-2">
                                      <v-card class="pa-2" cols="12" sm="6" md="10">
                                        <v-card-title class="measure_section_title">
                                          {{b.name}}
                                        </v-card-title>
                                        <v-card-text>
                                          <v-text-field 
                                            v-for="dimension in b.dimensions" 
                                            :key="dimension.id" 
                                            :label="dimension.label" 
                                            :title="dimension.label"
                                            
                                            :readonly="dimension.computed?true:false"
                                            v-model.number="variables[dimension.name]" 
                                            @keypress="isNumber($event)"
                                            @blur="handleBlur(dimension.name)"
                                          ></v-text-field>
                                        </v-card-text>
                                      </v-card>
                                    </v-col>
                                  </v-row>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>

                          </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" md="8" class="pl-2">
                          <v-card class="pa-2" cols="12" sm="6" md="10">
                            
                            <v-list>
                              <v-list-item v-for="block in quotation.areas.measure.sections[0].blocks" :key="block.id">
                                <v-list-item-content>
                                  <v-row no-gutters>
                                    <v-col cols="12" sm="12" md="12" class="pl-2">
                                      <v-card class="pa-2" cols="12" sm="6" md="10">
                                        <v-card-title class="measure_section_title">
                                          {{block.name}}
                                        </v-card-title>
                                        <v-card-text>
                                          <v-row cols="12">
                                            <v-col cols="12" sm="6" md="3" v-for="dimension in block.dimensions" :key="dimension.id">
                                              <v-text-field 
                                                :label="dimension.label"
                                                :title="dimension.label"
                                                :readonly="dimension.computed?true:false"
                                                v-model.number="variables[dimension.name]" 
                                                @keypress="isNumber($event)"
                                                @blur="handleBlur(dimension.name)"
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-card-text>
                                      </v-card>
                                    </v-col>
                                  </v-row>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>

                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-card v-if="quotation.configurator" class="body_section">
                  <div class="body_tot">Totale: € {{tot_body | formatNumber}}</div>
                  <v-tabs
                    v-model="tabs"
                    align-with-title
                    background-color="deep-purple accent-4"
                    center-active
                    dark
                  >
                    <v-tab
                      v-for="section in quotation.areas.body.sections"
                      :key="section.id"
                    >
                      <div>
                        <div>{{ section.name }}</div>
                        <div class="section_tot">€ {{section_tot[section.id] | formatNumber}}</div>
                      </div>
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tabs">
                    <v-tab-item
                      v-for="section in quotation.areas.body.sections"
                      :key="section.id"
                    >
                      <v-card flat>
                        <v-card-text>
                          
                            <v-list>
                              <v-list-item v-for="block in section.blocks" :key="block.id">
                                <v-list-item-content>
                                  <v-row no-gutters>
                                    <v-col cols="2" md="2" class="pr-2">
                                      <v-card class="pa-2" height="180">
                                        <v-card-title class="title_block" v-bind:title="block.name">{{block.name}}</v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                          <div class="block_tot">Totale blocco € {{block_tot[block.id] | formatNumber}}</div>
                                        </v-card-text>
                                      </v-card>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="10" class="pl-2">
                                      <v-card class="pa-2 box_components" cols="12" sm="6" md="10">
                                        <v-container>
                                          <v-slide-group multiple :show-arrows="false" active-class="success" class="component_slider">
                                            <v-row justify="center" align="center" class="my-1">

                                              <v-slide-item v-for="component in block.components" :key="component.id" v-slot="{ toggle }">
                                                
                                                <v-card
                                                  v-if="parseFloat(variables[component.d_name]) > 0"
                                                  class="ma-4"
                                                  :class="components_used.indexOf(component.id) > -1 ? 'success' : variables[component.d_name] ? '':'component_disabled'"
                                                  height="100"
                                                  width="230"
                                                  @click="toggle"
                                                >
                                                  <v-row
                                                    class="fill-height"
                                                    align="center"
                                                    justify="center"
                                                    @click="setUnsetComponents(component,block)"
                                                  >
                                                    <div class="component">{{component.name | capitalizeFirstLetter}}</div>
                                                    <div v-if="parseFloat(variables[component.d_name]) > 0" class="component_detail" v-bind:title="component.d_label">
                                                      {{variables[component.d_name] ? parseFloat(variables[component.d_name]) : 0}} {{component.product_um}} X €{{(parseFloat(component.product_price)*parseFloat(component.proportional_increase)) | formatNumber}} <span v-if="parseFloat(component.fixed_increase) > 0">(+{{parseFloat(component.fixed_increase) | formatNumber}} fisso)</span>
                                                    </div>
                                                    <div v-if="parseFloat(variables[component.d_name]) > 0" class="component_detail_tot">
                                                      € {{((parseFloat(variables[component.d_name]) * parseFloat(component.product_price))*parseFloat(component.proportional_increase))+parseFloat(component.fixed_increase) | formatNumber}}
                                                    </div>
                                                    <!--<v-scale-transition>
                                                      <v-icon
                                                        v-if="active || components_used.indexOf(component.id) > -1"
                                                        color="white"
                                                        size="48"
                                                        v-text="'mdi-close-circle-outline'"
                                                        class="remove_component"
                                                      ></v-icon>
                                                    </v-scale-transition>-->
                                                  </v-row>
                                                </v-card>
                                                <v-card
                                                  v-else
                                                  class="ma-4"
                                                  :class="components_used.indexOf(component.id) > -1 ? 'success' : parseFloat(variables[component.d_name]) > 0 ? '':'component_disabled'"
                                                  height="100"
                                                  width="230"
                                                >
                                                  <v-row
                                                    class="fill-height"
                                                    align="center"
                                                    justify="center"
                                                    @click="setUnsetComponents(component,block)"
                                                  >
                                                    <div class="component">{{component.name | capitalizeFirstLetter}}</div>
                                                    <div v-if="parseFloat(variables[component.d_name]) > 0" class="component_detail" v-bind:title="component.d_label">
                                                      {{variables[component.d_name] ? parseFloat(variables[component.d_name]) : 0}} {{component.product_um}} X €{{(parseFloat(component.product_price)*parseFloat(component.proportional_increase)) | formatNumber}} <span v-if="parseFloat(component.fixed_increase) > 0">(+{{parseFloat(component.fixed_increase) | formatNumber}} fisso)</span>
                                                    </div>
                                                    <div v-if="parseFloat(variables[component.d_name]) > 0" class="component_detail_tot">
                                                      € {{((parseFloat(variables[component.d_name]) * parseFloat(component.product_price))*parseFloat(component.proportional_increase))+parseFloat(component.fixed_increase) | formatNumber}}
                                                    </div>
                                                    <!--<v-scale-transition>
                                                      <v-icon
                                                        v-if="active || components_used.indexOf(component.id) > -1"
                                                        color="white"
                                                        size="48"
                                                        v-text="'mdi-close-circle-outline'"
                                                        class="remove_component"
                                                      ></v-icon>
                                                    </v-scale-transition>-->
                                                  </v-row>
                                                </v-card>
                                              </v-slide-item>

                                            </v-row>
                                          </v-slide-group>
                                        </v-container>
                                      </v-card>
                                    </v-col>
                                  </v-row>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
                <v-expansion-panels
                  multiple
                  focusable
                  v-model="panel2"
                >
                  <v-expansion-panel v-if="quotation.configurator">
                    <!--<v-expansion-panel-header>{{quotation.areas.footer.name}}</v-expansion-panel-header>-->
                    <v-expansion-panel-header v-slot="{ open }" class="">
                      <v-row no-gutters>
                        <v-col cols="4">
                          {{quotation.areas.footer.name}}
                        </v-col>
                        <v-col
                          cols="8"
                          class="text--secondary"
                        >
                          <v-fade-transition leave-absolute>
                            <span v-if="open" class="info-panel"></span>
                            <v-row
                              v-else
                              no-gutters
                              style="width: 100%"
                            >
                              <v-col cols="6">
                                Totale Struttura: € {{tot_body | formatNumber}}
                              </v-col>
                              <v-col cols="6">
                                Totale Preventivo: € {{tot_tot | formatNumber}}
                              </v-col>
                            </v-row>
                          </v-fade-transition>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row no-gutters>
                        <v-card
                          class="mx-auto"
                        >
                          <v-list
                            subheader
                            two-line
                          >
                            <v-subheader inset>Totali</v-subheader>

                            <v-list-item class="tot_item">
                              <v-list-item-avatar>
                                <v-icon
                                  class="deep-purple lighten-1"
                                  dark
                                >
                                  mdi-home-city
                                </v-icon>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title>Totale</v-list-item-title>

                                <v-list-item-subtitle>Totale lavorazioni</v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action>
                                € {{tot_body | formatNumber}}
                                <!--<v-btn icon>
                                  <v-icon color="grey lighten-1">mdi-information</v-icon>
                                </v-btn>-->
                              </v-list-item-action>
                            </v-list-item>

                            <v-list-item class="tot_item ricarico" title="L'importo è calcolato con i valori di ricarico_a (default 30%) e ricarico_b (default 25%) presenti nelle misure">
                              <v-list-item-avatar>
                                <v-icon
                                  class="green lighten-1"
                                  dark
                                >
                                  mdi-shield-account-variant
                                </v-icon>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title>Utile impresa e imprevisti</v-list-item-title>

                                <v-list-item-subtitle>Percentuale di utile di impresa e copertura imprevisti</v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action>
                                € {{tot_profit | formatNumber}}
                                <!--<v-btn icon>
                                  <v-icon color="grey lighten-1">mdi-information</v-icon>
                                </v-btn>-->
                              </v-list-item-action>
                            </v-list-item>

                            <v-list-item class="tot_item " title="L'importo è calcolato con il valore di provvigione_rappresentante presente nelle misure">
                              <v-list-item-avatar>
                                <v-icon
                                  class="orange lighten-1"
                                  dark
                                >
                                mdi-account-cash                  </v-icon>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title>Totale provvigione rappresentante</v-list-item-title>

                                <v-list-item-subtitle>Percentuale da corrispondere al rappresentante </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action>
                                € {{tot_prov | formatNumber}}
                                <!--<v-btn icon>
                                  <v-icon color="grey lighten-1">mdi-information</v-icon>
                                </v-btn>-->
                              </v-list-item-action>
                            </v-list-item>

                            <v-list-item class="tot_item">
                              <v-list-item-avatar>
                                <v-icon
                                  class="blue lighten-1"
                                  dark
                                >
                                  mdi-currency-eur
                                </v-icon>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title>Totale preventivo</v-list-item-title>

                                <v-list-item-subtitle>Somma del totale lavorazioni e dell'utile aziendale e imprevisti</v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action>
                                <b>€ {{tot_tot | formatNumber}}</b>
                                <!--<v-btn icon>
                                  <v-icon color="grey lighten-1">mdi-information</v-icon>
                                </v-btn>-->
                              </v-list-item-action>
                            </v-list-item>

                            <!--provvigione rappresentante!-->


                          </v-list>
                        </v-card>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                
              </v-container>
            </v-form>
          </div>
          
          </v-card>
        </v-row>
      </v-container>
      <v-speed-dial
            v-model=fab
            :top=top
            :bottom=bottom
            :right=right
            :left=left
            :direction=direction
            :open-on-hover=hover
            :transition=transition
          >
            <template v-slot:activator>
              <v-btn v-model="fab" color="blue darken-2" dark fab>
                <v-icon v-if="fab">
                  mdi-close
                </v-icon>
                <v-icon v-else>
                  mdi-text-box-multiple
                </v-icon>
              </v-btn>
            </template>
            <v-tooltip left v-if="userLoggedPermissions.manage_users !== undefined && userLoggedPermissions.manage_users.write ===1">
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab dark small v-bind="attrs" v-on="on" color="green" @click="saveQuotation">
                  <v-icon>mdi-content-save-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>Salva Preventivo</span>
            </v-tooltip>
            <v-tooltip left v-if="http_verb==='put' && userLoggedPermissions.manage_users.delete ===1">
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab dark small v-bind="attrs" v-on="on" color="red" @click="deleteQuotation">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Cancella Preventivo</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab dark small v-bind="attrs" v-on="on" color="indigo" @click="backToQuotations" >
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </template>
              <span>Vai alla lista</span>
            </v-tooltip>
          </v-speed-dial>
    </v-main>
  </v-app>
</template>

<script>
  import SideBar from '../components/SideBar.vue';
  import Header from '../components/Header.vue';
  
  //import { VueGoodTable } from 'vue-good-table';
  // import the styles
  //import 'vue-good-table/dist/vue-good-table.css'
  import { quotationsUrl, customersUrl, getHeader } from '../config.js';

  import router from '../router';

  import { store } from '../store';

  const axios = require('axios');

  const responseSuccessHandler = response => {
    return response;
  };

  const responseErrorHandler = error => {
    console.log('interceptor');
    if (error.response.status === 401) {
      router.push({name:'Login'});
    }

    return Promise.reject(error);
  };

  axios.interceptors.response.use(
    response => responseSuccessHandler(response),
    error => responseErrorHandler(error)
  );

  

  export default {
    props: {
      source: String,
    },
    components:{
      'my-side-bar':SideBar,
      'my-header':Header
    },
    data: () => ({
      direction: 'top',
      fab: false,
      fling: true,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-reverse-transition',
      dialog: false,
      drawer: true,
      isLoading: true,
      quotationId: null,
      offerId: 0,
      descriptionLimit: 60,
      entries: [],
      roles:[],
      permissions: [],
      objPermissions: {},
      rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
          password: value => {
            const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
            if(!value){
              if(this.http_verb == "post"){
                return false || 'Required.';
              }else{
                return true;
              }  
            }else{
              return pattern.test(value) || 'Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character'
            }
          }
      },
      http_verb: '',
      userLogged : {},
      userLoggedPermissions : {},
      panel: [0],
      panel2: [],
      customer : {
        firstname: '',
        lastname: '',
        company: '',
        obj:null
      },
      customer_list: [],
      search: null,
      configurators : [],
      quotation: {
        configurator : null,
        areas: {
          measure : {
            name: 'MISURE',
            sections_doc : [{blocks:[]}],
            sections: [{blocks:[]}]
          },
          body: {
            name: 'PREVENTIVO COSTI',
            sections : []
          },
          footer: {
            name: 'RIEPILOGO'
          }
        }
      }, 
      variables : {
      },
      formulas : {
        measure: {},
        component: {}
      },
      block_tot:{},
      section_tot: {},
      components_used : [],
      lastSectionId: 0,
      penultimateSectionId: 0,
      profit_a: 0.25,
      profit_b: 0.30
    }),
    watch: {
      search (val) {
        console.log(val);
        // Items have already been loaded
        if (val.length < 2 || val.length > 8) return

        // Items have already been requested
        if (this.isLoading) return

        this.isLoading = true

        var header = getHeader();

        axios.get(customersUrl + '?s=' + val, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                // handle success
                console.log(response.data);

                if(response.data.rows.length > 0){
                  
                  this.count = response.data.contRows
                  this.entries = response.data.rows;

                }else{
                  this.$fire({
                    title: "Errore!",
                    text: 'Non ci sono clienti configurati',
                    type: "error",
                    timer: 5000
                  });
                }

            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(() => (this.isLoading = false));

      },
    },
    async mounted () {
      console.log('quotationId', this.$route.params.quotationId);
      this.quotationId = this.$route.params.quotationId;

      console.log('offerId', this.$route.params.offerId);
      this.offerId = this.$route.params.offerId ? this.$route.params.offerId : 0;

      this.userLogged = store.state.user;
      this.userLoggedPermissions = store.state.permissions;

      if(this.userLoggedPermissions.manage_quotations === undefined){
        this.$fire({
          title: "Accesso Negato",
          text: "Non si hanno i privilegi per accedere a questa pagina",
          type: "error",
          timer: 5000
        }).then(r => {
          console.log(r.value);
        });

        router.push({name:'Home'});

      }

      await this.loadConfigurators();

      if(this.quotationId){
        this.http_verb = 'put';
        this.getQuotation();
      }else{
        this.http_verb = 'post';
      }

      if(this.offerId){
        this.loadCustomerFromOffer();
        this.panel = [1]
      }

      this.isLoading = false;
    },
    methods: {
      updateDrawer(value){
        this.drawer = value;
      },
      saveQuotation(){

        let self = this;

        if(!this.customer.obj){
          this.$fire({
            title: "Errore nei dati!",
            text: 'Selezionare un Cliente per poter salvare il preventivo',
            type: "error",
            timer: 5000
          }).then(r => {
            console.log(r.value);
          });
          return false;
        }

        if(!this.quotation.configurator){
          this.$fire({
            title: "Errore nei dati!",
            text: 'Selezionare una tipologia di preventivo per poter salvare',
            type: "error",
            timer: 5000
          }).then(r => {
            console.log(r.value);
          });
          return false;
        }

        this.isLoading = true;

        // Dovrei fare dei controlli che ci siano almeno dei valori scritti.....

        //console.log(this.variables);

        var comp_used = this.getComponentsUsed();
        //console.log(comp_used);
        var header = getHeader();

        var objToSave = {
          quotation : {
            offer_id : this.offerId,
            vars : this.variables,
            configurator : this.quotation.configurator,
            components_used : comp_used,
            customer : this.customer,
            total : this.tot_tot
          }
        };

        if (this.http_verb === 'put'){

          axios.put(quotationsUrl + '/quote/' + this.quotationId, objToSave, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                console.log(response);

                if(response.data.result === "OK"){
                  
                  this.$fire({
                    title: "Dati salvati",
                    text: "Salvataggio avvenuto con successo",
                    type: "success",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }else{

                  var text = response.data.msg != '' ? response.data.msg : "Dati inseriti non validi, si prega di verificare.";
                  this.$fire({
                    title: "Errore nei dati!",
                    text: text,
                    type: "error",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }

                this.isLoading = false;
                
            })
            .catch(function (error) {
                // handle error
                console.log(error);

                self.isLoading = false;

                self.$fire({
                    title: "Errore nel salvataggio!",
                    text: error,
                    type: "error"
                  }).then();
            }).finally(function(){
              
            });
          
        }else{

          axios.post(quotationsUrl + '/quote', objToSave, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                console.log(response);

                if(response.data.result === "OK"){
                  
                  //this.backToQuotations();
                  router.push({ name: 'Quotation', params: { quotationId: response.data.data.q_id, offerId: this.offerId } });
                  
                  this.$fire({
                    title: "Dati salvati",
                    text: "Salvataggio avvenuto con successo",
                    type: "success",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }else{

                  var text = response.data.msg != '' ? response.data.msg : "Dati inseriti non validi, si prega di verificare.";
                  this.$fire({
                    title: "Errore nei dati!",
                    text: text,
                    type: "error",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }

                this.isLoading = false;
                
            })
            .catch(function (error) {
                // handle error
                console.log(error);
                self.isLoading = false;

                self.$fire({
                    title: "Errore nel salvataggio!",
                    text: error,
                    type: "error"
                  }).then();
            });

        }
        
      },
      backToQuotations(){
        router.push({name:'Quotations'});
      },
      deleteQuotation(){
        
        this.$fire({
          title: 'Sei sicuro?',
          text: "L'operazione non sarà reversibile!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, cancella!'
        }).then(r => {
            if(r.value){
              
              this.isLoading = true;

              var header = getHeader();

              axios.delete(quotationsUrl + '/quote/' + this.quotationId, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                console.log(response);

                if(response.data.affected == "1"){
                  
                  this.$fire({
                    title: "Cancellato!",
                    text: "Preventivo cancellato con successo",
                    type: "success",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                  this.backToQuotations();

                }else{

                  var text = response.data.msg != '' ? response.data.msg : "E' avvenuto un errore, si prega di riprovare.";
                  this.$fire({
                    title: "Errore!",
                    text: text,
                    type: "error",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }
                this.isLoading = false;
                
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            });

          }
        });

      },
      async loadConfigurators(){

        var header = getHeader();

        return axios.get(quotationsUrl + '/configurators', {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                // handle success
                //console.log(response.data);

                if(response.data.rows.length > 0){
                  
                  this.configurators = response.data.rows;

                }else{
                  this.$fire({
                    title: "Errore!",
                    text: 'Non ci sono tipologie di preventivo configurate',
                    type: "error",
                    timer: 5000
                  });
                }
                
                this.isLoading = false;

            })
            .catch(function (error) {
                // handle error
                console.log(error);
            });

      },
      changeConfigurator(){

        //this.quotation.areas = [];
        //this.panel.splice(1, 1);
        //console.log(this.quotation.configurator);

        this.isLoading = true;

        var header = getHeader();

        axios.get(quotationsUrl + '/configurators/' + this.quotation.configurator.id, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                // handle success
                //console.log(response.data);
                //console.log(response.data.structure.length);

                if(response.data.structure.length !== 0){
                  
                  //console.log(response.data.structure);
                  
                  this.generateBlocksTot(response.data.structure.body.sections);
                  this.quotation.areas.body.sections = response.data.structure.body.sections;

                  // Salvo le formule a parte
                  this.extractFormulas(response.data.structure.measures.sections[0].blocks);
                  this.extractFormulas(response.data.structure.measures_in_doc.sections[0].blocks);

                  this.quotation.areas.measure.sections = response.data.structure.measures.sections;
                  this.quotation.areas.measure.sections_doc = response.data.structure.measures_in_doc.sections;

                  

                  //console.log(response.data.structure.body.sections[0].id);
                  if(response.data.structure.body.sections[0].id){
                    //this.loadComponents(response.data.structure.body.sections[0].id);
                  }

                  this.applyAllFormulas();
                  
                  // Ricalcolo i blocchi
                  for (const s in this.quotation.areas.body.sections){

                    for (const b in this.quotation.areas.body.sections[s].blocks) {

                      this.calculateTotBlock(this.quotation.areas.body.sections[s].blocks[b]);

                    }
                    this.calculateTotSection(this.quotation.areas.body.sections[s]);
                    this.penultimateSectionId = this.lastSectionId;
                    this.lastSectionId = this.quotation.areas.body.sections[s].id;
                  }

                  if(this.http_verb === 'post'){
                    this.panel = [2];
                  }else{
                    this.panel = [];
                  }
                  
                  this.panel2 = [0];
                  

                }else{
                  this.$fire({
                    title: "Errore!",
                    text: 'Non ci sono aree configurate per quest tipologie di preventivo',
                    type: "error",
                    timer: 5000
                  });
                }
                
                this.isLoading = false;

            })
            .catch(function (error) {
                // handle error
                console.log(error);
            });

      },
      isNumber(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      handleBlur(v){

        //console.log(v);
        if(this.variables[v] == ''){
          this.variables[v] = 0;
        }

        if(this.formulas.measure[v] != undefined){
          //console.log('devo applicare una formula');
          
          this.formulas.measure[v].forEach(formula =>{
            
            var ck = true;
            var params = [];

            formula.params.forEach(el => {
              //console.log(this.variables[el]);
              if(this.variables[el] == undefined || this.variables[el].length == 0){
                ck = false;
              }else{
                params.push(parseFloat(this.variables[el]));
              }
            });
            //console.log(ck);

            if(ck){
              var func = new Function("return " + formula.formula)();
              var res = func(params);
              //console.log(res);
              this.variables[formula.result] = res.toFixed(3);
            }

          });
          
          //console.log(this.variables);
          
        }

        // Ricalcolo i blocchi se è cambiato qualche cosa
        for (const s in this.quotation.areas.body.sections){

          for (const b in this.quotation.areas.body.sections[s].blocks) {

            this.calculateTotBlock(this.quotation.areas.body.sections[s].blocks[b]);

          }

          this.calculateTotSection(this.quotation.areas.body.sections[s]);
        }
          

      },
      extractFormulas(blocks){

        //console.log('extract formula');
        //console.log(blocks);
        for (const b in blocks) {

          //console.log(blocks[b]);

          for (const d in blocks[b].dimensions) {

            if(blocks[b].dimensions[d].computed == 1){
              //console.log(this.quotation.areas.measure.sections[0].blocks[b].dimensions[d].name);
              //console.log(this.quotation.areas.measure.sections[0].blocks[b].dimensions[d].formula); 
              var f = this.sanitizeFormula(blocks[b].dimensions[d].formula);
              f = this.parseFormula(f);
              //console.log(f);

              if (f.bind == true){

                f.vars.forEach(element => {
                  if(this.formulas.measure[element] == undefined){
                    this.formulas.measure[element] = [];
                  }
                  this.formulas.measure[element].push({
                    'formula' : f.string,
                    'params' : f.vars,
                    'result' : blocks[b].dimensions[d].name
                  });
                  var key = blocks[b].dimensions[d].name;
                  this.$set(this.variables, key, 0);

                  //this.variables[blocks[b].dimensions[d].name] = 0;
                });

              }else{

                var func = new Function("return " + f.string)();
                var res = func();
                //console.log(res);
                this.$set(this.variables, blocks[b].dimensions[d].name, res);

              }
              
            }else{
                var key = blocks[b].dimensions[d].name;
                
                if(!this.variables[key]){
                  this.$set(this.variables, key, 0);
                }
                
            }
            
          }

        }

        //console.log(this.formulas);
        
      },
      generateBlocksTot(sections){

        //console.log('generateBlocksTot');
        //console.log(sections);

        for (const s in sections) {

          for (const b in sections[s].blocks) {

            this.$set(this.block_tot, sections[s].blocks[b].id, 0);

          }

        }

        //console.log(this.block_tot);

      },
      sanitizeFormula(string){

        return string

      },
      parseFormula(string){

        //console.log(string);
        const stringExtractor = this.extract();       
        const vars = stringExtractor(string);
        //console.log(vars);

        var myVars = [];
        var bind = false;

        if(vars.length > 0){

          for(var i in vars){
            string = string.replace('[' + vars[i] + ']' , 'myVar_' + i);
            myVars.push('myVar_' + i);
          }
          //console.log(string);
          bind = true;

        }

        string = this.createFunction(string,myVars);

        //console.log(string);

        return {string: string, vars: vars, bind: bind};

      },
      extract() {
          const matcher = new RegExp(/\[(.*?)\]/,'gm');
          const normalise = (str) => str.slice(1,-1);
          return function(str) {
              var res = [];
              var m = str.match(matcher);
              if(m){
                res = m.map(normalise);
              }
              return res;
          }
      },
      createFunction(string, params){
        
        var f = '';

        if(params.length > 0){
          f = 'function([' + params.join(',') + ']){ return ' + string + '; }';
        }else{
          f = 'function(){ return ' + string + '; }';
        }
        
        return f;

      },
      setUnsetComponents(component, block){

        // console.log('setUnsetComponents');
        console.log(component);
        // console.log(block);
        // console.log(this.components_used);

        if(!this.variables[component.d_name] || this.variables[component.d_name] == 0){
          return false;
        }

        if(component.used === true){
          component.used = false;
        }else{
          component.used = true;
        }

        const index = this.components_used.indexOf(component.id);
        if(index > -1){
          this.components_used.splice(index, 1); 
        }else{
          this.components_used.push(component.id)
        }

        this.calculateTotBlock(block);

        //console.log(this.quotation.areas.body.sections);
        var section = this.quotation.areas.body.sections.filter(s => {
          return s.id == block.section_id;
        });
        //console.log(section);

        if(section[0]){
          this.calculateTotSection(section[0]);
        }

        //console.log(this.block_tot);
        //console.log(this.components_used);
        
      },
      calculateTotBlock(block){

        var tot = 0;

        block.components.forEach(c => {

          if(this.components_used.indexOf(c.id) > -1){
            var price = parseFloat(c.product_price);
            var inc_f = parseFloat(c.fixed_increase);
            var inc_p = parseFloat(c.proportional_increase);
            var v = this.variables[c.d_name] ? parseFloat(this.variables[c.d_name]) : 0;
            var sub_tot = ((price * v) * inc_p) + inc_f;
            tot += sub_tot;
          }

          this.$set(this.block_tot, block.id, tot);

        });

      },
      calculateTotSection(section){
        
        var tot = 0;
        section.blocks.forEach(b => {
          if(this.block_tot[b.id]){
            tot += this.block_tot[b.id];
          }
        });
        
        this.$set(this.section_tot, section.id, tot);

      },
      getQuotation(){

        //console.log('getquote');
        var header = getHeader();

        axios.get(quotationsUrl + '/quote/' + this.quotationId, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                // handle success
                //console.log(response.data);
                //console.log(response.data.quotation.configurator_id);
                if(response.data.quotation.configurator_id){
                  this.quotation.configurator = {
                    'id' : response.data.quotation.configurator_id,
                    'name' : response.data.quotation.configurator_name
                    };
                  this.changeConfigurator();

                  if(response.data.customer_quotation){
                    this.customer.obj = response.data.customer_quotation;
                    this.customer.firstname = this.customer.obj.nome;
                    this.customer.lastname = this.customer.obj.cognome;
                    this.customer.company = this.customer.obj.denominazione;
                  }

                  if(response.data.dimension_quotation){

                    response.data.dimension_quotation.forEach(m => {
                      this.$set(this.variables, m.dimension_name, m.measure);
                    });
                    
                  }

                  this.applyAllFormulas();

                  if(response.data.component_quotation){

                    //console.log(this.components_used);
                    response.data.component_quotation.forEach(c => {
                      this.components_used.push(c.component_id);
                    });
                    //console.log(this.components_used);

                  }

                  // Ricalcolo i blocchi
                  for (const s in this.quotation.areas.body.sections){

                    for (const b in this.quotation.areas.body.sections[s].blocks) {

                      this.calculateTotBlock(this.quotation.areas.body.sections[s].blocks[b]);

                    }
                  }

                }

            })
            .catch(function (error) {
                // handle error
                console.log(error);
                //
            });

      },
      getComponentsUsed(){

        return this.components_used;

      },
      applyAllFormulas(){

        // console.log('start applyAllFormulas()');
        // console.log(this.formulas.measure);

        for (const [key] of Object.entries(this.formulas.measure)) {
          //console.log(key);
          this.handleBlur(key);
        }

        // console.log('end applyAllFormulas()');

      },
      customerSelected(){
        console.log('customerSelected');
        console.log(this.customer.obj);
        if(this.customer.obj){
          this.customer.firstname = this.customer.obj.nome;
          this.customer.lastname = this.customer.obj.cognome;
          this.customer.company = this.customer.obj.denominazione;
        }
      },
      loadCustomerFromOffer(){

        console.log('loadCustomerFromOffer');

        var header = getHeader();

        axios.get(quotationsUrl + '/customerInfoByOffer/' + this.offerId, {
          headers: {
            'Accept' : header.Accept,
            'Authorization': header.Authorization
          }
        })
        .then((response) => {
            // handle success
            console.log(response.data);
            if(response.data.customer_quotation){
              this.customer.obj = response.data.customer_quotation;
              this.customer.firstname = this.customer.obj.nome;
              this.customer.lastname = this.customer.obj.cognome;
              this.customer.company = this.customer.obj.denominazione;
            }

        })
        .catch(function (error) {
            // handle error
            console.log(error);
        });

      }
    },
    computed: {
      user(){
        return this.$store.state.user;
      },
      items () {
        return this.entries.map(entry => {
          var Description = '';

          if(entry.denominazione.length > 0){
            Description = entry.denominazione + ' (' + entry.cognome + ' ' + entry.nome + ')';
          }else{
             Description = entry.cognome + ' ' + entry.nome;
          }

          return Object.assign({}, entry, { Description })
        })
      },
      tot_body() {
        var tot = 0;
        if(this.section_tot){
          for (const [key, value] of Object.entries(this.section_tot)) {
            console.log(key);
            tot += parseFloat(value);
          }
        }
        return tot;
      },
      tot_profit(){
        var tot_a = 0;
        var tot_b = 0;
        if(this.section_tot){
          for (const [key, value] of Object.entries(this.section_tot)) {
            //console.log(key);
            if(key != this.lastSectionId && key != this.penultimateSectionId){
              tot_a += parseFloat(value);
            }
            if(key == this.penultimateSectionId){
              tot_b += parseFloat(value);
            }
          }
        }
        var p_a = this.variables['ricarico_a'] != undefined ? parseFloat(this.variables['ricarico_a'])/100 : this.profit_a;
        var p_b = this.variables['ricarico_b'] != undefined ? parseFloat(this.variables['ricarico_b'])/100 : this.profit_b;
        // console.log('Profit a: ' + p_a);
        // console.log('Profit b: ' + p_b);
        tot_a = tot_a * p_a;
        tot_b = tot_b * p_b;
        // console.log('Tot a: ' + tot_a);
        // console.log('Tot b: ' + tot_b);
        return (tot_a + tot_b);
      },
      tot_tot(){
        var tot = 0;

        tot = this.tot_body + this.tot_profit + this.tot_prov;

        return tot;
      },

      tot_prov(){
      //aggiunta variabile provvigione
      var prov = this.variables['provvigione_rappresentante'] != undefined ? parseFloat(this.variables['provvigione_rappresentante'])/100 : this.profit_a;
      var tot = 0;
      tot = this.tot_body + this.tot_profit;
      return (tot * prov);

      }
    }
  }
</script>

<style scoped>
.v-card{
  width:100%;
}
span.txt-info{
  color:grey;
  font-style: italic;
  font-size: 10px;
}
/* This is for documentation purposes and will not be needed in your application */
   .v-speed-dial {
    position: fixed;
  }

   .v-btn--floating {
    position: relative;
  }

  span.info-panel{
    font-style: italic;
  }
  .body_section{
    margin-top:10px;
    margin-bottom: 10px;
  }
  .box_customer{
    background-color: yellow;
  }
  .box_type_configurator{
    background-color: aquamarine;
  }
  .box_measure{
    background-color: salmon;
  }
  div.section_total{
    font-size: 8px;

  }
  div.component{
    position: absolute;
    top: 10px;
    width: 220px;
    text-align: center;
    font-weight: bold;
  }
  i.remove_component{
    position: absolute;
    opacity: 0.2;
  }
  div.box_components{
    min-height: 180px;
  }
  div.section_tot,
  div.block_tot{
    font-size: 12px;
    font-style: italic;
  }
  div.component_detail{
    position: absolute;
    top: 70px;
    font-size: 10px;
    font-style: italic;
  }
  div.component_detail_tot{
    position: absolute;
    top: 85px;
    font-size: 10px;
    font-style: italic;
    font-weight: bold;
  }
  div.body_tot{
    background-color: #6200ea !important;
    border-color: #6200ea !important;
    color:white;
    font-weight: bold;
    text-align: right;
    padding-right:30px;
  }
  div.v-card__title.title_block{
    min-height: 120px;
    max-height: 120px;
    align-items: unset;
    overflow: hidden;
    font-size:16px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
  }
  div.measure_section_title{
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
  }
  div.component_slider{
    width: 1150px !important;
  }
  div.ma-4.v-card.v-sheet.theme--light.component_disabled{
    cursor: not-allowed;
    color: rgb(200, 200, 200);
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 0%), 0px 2px 2px 0px rgb(0 0 0 / 0%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  }
  div.ma-4.v-card.v-sheet.theme--light.component_disabled:focus:before{
    background-color: white;
    opacity: 1;
  }
  div.tot_item:hover{
    background-color: rgb(243, 243, 243);
  }
  div.ricarico{
    cursor:help;
  }
</style>
